import { LoaderCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import { JOB_RUN_STATE_LABELS, JOB_RUN_STATE_STYLES } from '@/lib/jobRuns'
import type { JobRunState } from '@/lib/jobRuns'

const badgeBaseClass = 'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium'

export function JobStatusBadge({ state }: { state: JobRunState }): React.ReactElement {
  const isRunning = state === 'running'

  return (
    <span className={cn(badgeBaseClass, JOB_RUN_STATE_STYLES[state])}>
      {isRunning && <LoaderCircle className="size-3 animate-spin" />}
      {JOB_RUN_STATE_LABELS[state]}
    </span>
  )
}
